import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const NetworkTileBlocks24h = ({ data, formatNumber, animate }) => {
  const numberValue = data?.s091?.btc_historical?.Data?.Data &&
    data.s091.btc_historical.Data.Data[1] &&
    data.s091.btc_historical.Data.Data[0]
    ? `${formatNumber(data.s091.btc_historical.Data.Data[1].block_height - data.s091.btc_historical.Data.Data[0].block_height)} Blocks`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="New Blocks 24h" value={numberValue} />
    </ThemedFlex>
  );
};